<template>
  <div class="page">
    <!-- <div v-html="sHtmlText"></div> -->
    <div class="banner">
      <div class="contnet">
        <div class="co1">实付金额</div>
        <div class="co2" v-if="payInfo"><span style="font-size: 20px">¥</span>{{ Number(payInfo.payMoney).toFixed(2) }}</div>
        <div class="co3">
          剩余支付时间 <span style="color: #4076f6">{{ timeLeft }}</span>
        </div>
        <div class="typeBox">
          <div class="cro">选择支付方式</div>
          <div class="zfBox">
            <van-radio-group v-model="radio">
              <van-cell-group>
                <van-cell clickable @click="radio = 'A01'" class="tyebox">
                  <div class="zfTypeBox">
                    <div>
                      <img src="../../assets/images/zfb@2x.png" alt="" />
                    </div>
                    <div style="margin-left: 10px">支付宝支付</div>
                  </div>
                  <template #right-icon>
                    <van-radio name="A01" />
                  </template>
                </van-cell>
                <!-- <van-cell clickable @click="radio = 'W01'" class="tyebox">
                  <div class="zfTypeBox">
                    <div>
                      <img src="../../assets/images/wx@2x.png" alt="" />
                    </div>
                    <div style="margin-left: 10px">微信支付</div>
                  </div>
                  <template #right-icon>
                    <van-radio name="W01" />
                  </template>
                </van-cell> -->
              </van-cell-group>
            </van-radio-group>
          </div>

          <div class="btn" @click="pay">立即支付</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { payEnd } from '@/api/order';
import { toTradeQuery } from '@/api/order';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      radio: 'A01',
      payInfo: {},
      sHtmlText: '',
      remainedTime: 0,
      intervalId: null,
      pollingTimer: null, // 轮询定时器
      isPolling: false // 防止重复开启轮询
    };
  },
  // 监听属性 类似于data概念
  computed: {
    timeLeft() {
      return this.formatTime(this.remainedTime);
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // stopPolling() {
    //   if (this.pollingTimer) {
    //     clearInterval(this.pollingTimer);
    //     this.pollingTimer = null;
    //   }
    //   this.isPolling = false;
    // },
    //支付
    pay() {
      if (this.radio == 'A01') {
        let data = {
          ordPayType: this.radio, //支付类型
          orderId: this.payInfo.orderId
          // openId: ''
        };
        payEnd(data).then(res => {
          console.log(res);
          //支付宝支付
          // this.sHtmlText = res.data.data.sHtmlText;
          window.location.href = res.data.data.payinfo;
          // this.pollingTimer = setInterval(() => {
          //   toTradeQuery({ orderId: this.payInfo.orderId, ordPayType: 'A01' })
          //     .then(res => {
          //       const result = res?.data?.data?.result;
          //       console.log('对账结果:', result);

          //       if (result !== '2') {
          //         this.stopPolling();

          //         this.$utils.showToast('支付成功！');
          //         this.$router.replace({
          //           path: '/paySuccess',
          //           query: {
          //             orderNo:this.payInfo.orderNo,
          //             dz: 1
          //           }
          //         });
          //       } else {
          //         this.$utils.showToast(res.data.data.msg);
          //         this.$router.replace('/myOrder');
          //       }
          //     })
          //     .catch(err => {
          //       console.error('对账请求失败:', err);
          //     });
          // }, 1000);

          this.$nextTick(() => {
            this.$router.replace({
              path: '/queryPay',
              query: {
                id: this.payInfo.orderId,
                type: 1 //1是支付宝
              }
            });
            window.document.forms[0].submit();
          });
        });
      } else {
        let data = {
          ordPayType: this.radio, //支付类型
          orderId: this.payInfo.orderId
          // openId: ''
        };
        payEnd(data).then(res => {
          this.$router.replace({
            path: '/queryPay',
            query: {
              id: this.payInfo.orderId,
              type: 2 //2是wx
            }
          });
          window.location.href = res.data.data.payinfo;
          // window.location.href = res.data.data.mWebUrl;
        });
      }
    },
    formatTime(time) {
      const hours = Math.floor(time / 3600);
      const minutes = Math.floor((time % 3600) / 60);
      const seconds = time % 60;
      return [hours, minutes, seconds].map(this.padTime).join(':');
    },
    padTime(value) {
      return value.toString().padStart(2, '0');
    },
    startCountdown() {
      this.intervalId = setInterval(() => {
        if (this.remainedTime === 0) {
          this.clearCountdown();
        } else {
          this.remainedTime--;
        }
      }, 1000);
    },
    clearCountdown() {
      clearInterval(this.intervalId);
      this.$router.replace('/myOrder');
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.payInfo = this.$route.query;
    this.remainedTime = this.payInfo.remainedTime;
    setTimeout(() => {
      this.startCountdown();
    }, 500);
    this.$nextTick(() => {
      const scrollContainer = document.querySelector('.page');
      if (scrollContainer) {
        scrollContainer.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    });
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.$nextTick(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.banner {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;
  .contnet {
    padding: 30px 15px;
    .co1 {
      text-align: center;
      font-size: 15px;
      color: #333;
    }
    .co2 {
      text-align: center;
      margin-top: 20px;
      font-weight: bold;
      font-size: 36px;
      color: #333333;
    }
    .co3 {
      text-align: center;
      color: #666666;
      font-size: 13px;
      margin-top: 8px;
    }
    .typeBox {
      margin-top: 46px;
      .cro {
        font-weight: 500;
        font-size: 15px;
        color: #666666;
        margin-bottom: 6px;
      }
      .zfBox {
        .zfTypeBox {
          display: flex;
          align-items: center;
          img {
            margin-top: 6px;
            width: 24px;
            height: 24px;
          }
          font-size: 16px;
          color: #333;
          font-weight: 600;
        }
      }
      .btn {
        margin: 50px auto;
        width: 250px;
        height: 48px;
        background: linear-gradient(90deg, #ff8285 0%, #e74f52 100%);
        border-radius: 8px 8px 8px 8px;
        text-align: center;
        line-height: 48px;
        color: #fff;
        font-size: 15px;
      }
    }
  }
}
.tyebox {
  margin-top: 10px !important;
  border: 0 !important;
  background: #f6f8fa !important;
  border-radius: 8px 8px 8px 8px !important;
}
[class*='van-hairline']::after {
  border: 0 !important;
}
</style>
